import Vue from 'vue'

import DatePick from '@/Components/DatePick'
import NumberInput from '@/Components/NumberInput'
import FilterSelect from '@/Components/FilterSelect'

Vue.component('date-pick', DatePick)
Vue.component('number-input', NumberInput)
Vue.component('filter-select', FilterSelect)
